var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoL(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-2 {\n        fill: #04bf7b;\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-2);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 653.41,
    y1: 439.19,
    x2: 410.74,
    y2: 439.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#038c5a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#039e65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#03b071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#03bb78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04bf7b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 533.68,
    y1: 556.65,
    x2: 533.68,
    y2: 378.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#04bf7b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#04bc79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#04b373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#05a36a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#078d5c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#09714b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#0b593c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 528.87,
    y1: 341.32,
    x2: 524.11,
    y2: 457.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#04bf7b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#04ba78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#05ae71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#069a64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#087e52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#0a5a3c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#0b593c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 438.34,
    y1: 410.26,
    x2: 660.88,
    y2: 439.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#0b593c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#09744c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#078f5d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#05a46a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#04b373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#04bc79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04bf7b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M289.35,773.75v13.9h32.67v78.14h17.79v-78.14h32.68v-13.9h-83.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M479.15,811.28c-1-5.59-3.01-10.87-6.04-15.82-4.53-7.4-10.6-13.06-18.22-16.99-7.62-3.93-16.19-5.9-25.73-5.9s-18.71,2.04-26.36,6.16c-7.64,4.1-13.64,9.86-17.99,17.29-2.86,4.87-4.77,9.96-5.74,15.26-.54,2.78-.79,5.62-.79,8.53s.24,5.75,.73,8.5c.97,5.49,2.9,10.62,5.79,15.45,4.35,7.22,10.43,12.9,18.22,17.03,7.79,4.13,16.45,6.18,25.99,6.18s18.35-2.03,26.06-6.09c7.7-4.06,13.77-9.77,18.18-17.12,2.92-4.87,4.89-10.02,5.87-15.45,.51-2.76,.76-5.61,.76-8.5s-.25-5.76-.75-8.53Zm-26.7,31.45c-6.09,5.92-13.85,8.89-23.29,8.89-6.24,0-11.83-1.35-16.77-4.02-4.94-2.69-8.79-6.46-11.57-11.33-1.41-2.49-2.46-5.15-3.16-7.96-.66-2.69-.98-5.53-.98-8.5s.31-5.84,.96-8.53c.66-2.83,1.68-5.49,3.05-7.98,2.69-4.86,6.51-8.63,11.5-11.33,4.98-2.71,10.6-4.06,16.83-4.06s11.84,1.35,16.83,4.02c4.98,2.69,8.84,6.47,11.59,11.37,1.4,2.5,2.45,5.16,3.13,7.98,.66,2.7,.98,5.54,.98,8.53s-.31,5.84-.96,8.5c-1.32,5.59-4.03,10.4-8.16,14.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M541.62,773.75h-14.29l-40.78,92.04h17.92l29.58-70.82,30.63,70.82h18.45l-41.5-92.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M686.55,811.28c-1-5.59-3.01-10.87-6.04-15.82-4.53-7.4-10.6-13.06-18.22-16.99-7.62-3.93-16.19-5.9-25.73-5.9s-18.71,2.04-26.36,6.16c-7.64,4.1-13.64,9.86-17.97,17.29-2.86,4.87-4.77,9.96-5.74,15.26-.52,2.78-.79,5.62-.79,8.53s.25,5.75,.73,8.5c.97,5.49,2.9,10.62,5.79,15.45,4.34,7.22,10.41,12.9,18.21,17.03,7.79,4.13,16.47,6.18,25.99,6.18s18.35-2.03,26.06-6.09c7.72-4.06,13.77-9.77,18.18-17.12,2.92-4.87,4.89-10.02,5.87-15.45,.51-2.76,.76-5.61,.76-8.5s-.25-5.76-.75-8.53Zm-26.7,31.45c-6.08,5.92-13.85,8.89-23.29,8.89-6.24,0-11.83-1.35-16.77-4.02-4.94-2.69-8.79-6.46-11.55-11.33-1.43-2.49-2.48-5.15-3.17-7.96-.66-2.69-.98-5.53-.98-8.5s.31-5.84,.96-8.53c.67-2.83,1.69-5.49,3.07-7.98,2.67-4.86,6.51-8.63,11.49-11.33,4.99-2.71,10.6-4.06,16.83-4.06s11.86,1.35,16.83,4.02c4.99,2.69,8.86,6.47,11.59,11.37,1.4,2.5,2.45,5.16,3.13,7.98,.67,2.7,1,5.54,1,8.53s-.31,5.84-.96,8.5c-1.32,5.59-4.05,10.4-8.17,14.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M780.45,773.75l-30.24,36.3-30.25-36.3h-16.01v92.04h17.79v-64.64h.52l26.62,32.42h2.5l26.62-32.42h.52v64.64h17.79v-92.04h-15.88Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M479.9,819.81c0,2.9-.25,5.74-.76,8.5h-100.11c-.5-2.75-.73-5.58-.73-8.5s.25-5.75,.79-8.53h100.07c.5,2.76,.75,5.61,.75,8.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M687.3,819.81c0,2.9-.25,5.74-.76,8.5h-100.1c-.48-2.75-.73-5.58-.73-8.5s.26-5.75,.79-8.53h100.06c.5,2.76,.75,5.61,.75,8.53Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M411.49,536.49c-9.9,0-19.8-3.77-27.34-11.3l-58.66-58.66c-15.07-15.07-15.07-39.6,0-54.67l58.66-58.66c15.08-15.07,39.6-15.07,54.67,0l58.66,58.66c15.07,15.07,15.07,39.6,0,54.67l-58.66,58.66c-7.54,7.54-17.44,11.3-27.34,11.3Zm0-161.46c-1.42,0-2.85,.53-3.9,1.59l-58.66,58.66c-2.12,2.12-2.12,5.69,0,7.81l58.66,58.66c2.11,2.12,5.7,2.12,7.81,0l58.66-58.66c2.12-2.12,2.12-5.69,0-7.81l-58.66-58.66c-1.06-1.06-2.48-1.59-3.9-1.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M533.68,659.08c-9.9,0-19.8-3.77-27.34-11.3l-58.66-58.66c-15.07-15.07-15.07-39.6,0-54.67l58.66-58.66c15.08-15.07,39.6-15.07,54.67,0l58.66,58.66c15.07,15.07,15.07,39.6,0,54.67l-58.66,58.66c-7.54,7.54-17.44,11.3-27.34,11.3Zm0-161.46c-1.42,0-2.85,.53-3.9,1.59l-58.66,58.66c-2.12,2.12-2.12,5.69,0,7.81l58.66,58.66c2.11,2.12,5.7,2.12,7.81,0l58.66-58.66c2.12-2.12,2.12-5.69,0-7.81l-58.66-58.66c-1.06-1.06-2.48-1.59-3.9-1.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M529.91,413.01c-9.9,0-19.8-3.77-27.34-11.3l-58.66-58.66c-15.07-15.07-15.07-39.6,0-54.67l58.66-58.66c15.08-15.07,39.6-15.07,54.67,0l58.66,58.66c15.07,15.07,15.07,39.6,0,54.67l-58.66,58.66c-7.54,7.54-17.44,11.3-27.34,11.3Zm0-161.46c-1.42,0-2.85,.53-3.91,1.59l-58.66,58.66c-2.12,2.12-2.12,5.69,0,7.81l58.66,58.66c2.11,2.12,5.7,2.12,7.81,0l58.66-58.66c2.12-2.12,2.12-5.69,0-7.81l-58.66-58.66c-1.06-1.06-2.48-1.59-3.9-1.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M652.1,535.6c-9.9,0-19.8-3.77-27.34-11.3l-58.66-58.66c-15.07-15.07-15.07-39.6,0-54.67l58.66-58.67c15.08-15.07,39.6-15.07,54.67,0l58.66,58.66c15.07,15.07,15.07,39.6,0,54.67l-58.66,58.66c-7.54,7.54-17.44,11.3-27.34,11.3Zm0-161.46c-1.42,0-2.85,.53-3.91,1.59l-58.66,58.66c-2.12,2.12-2.12,5.69,0,7.81l58.66,58.66c2.11,2.12,5.7,2.12,7.81,0l58.66-58.66c2.12-2.12,2.12-5.69,0-7.81l-58.66-58.66c-1.06-1.06-2.48-1.59-3.9-1.59Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 498.13,
    y: 324.42,
    width: 33.14,
    height: 256.67,
    transform: "translate(-169.39 496.55) rotate(-45)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "626.27 525.57 444.79 344.08 468.2 320.64 529.27 381.71 649.7 502.14 626.27 525.57"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 392.53,
    y: 417.96,
    width: 38.01,
    height: 38.01,
    rx: 8.2,
    ry: 8.2,
    transform: "translate(429.52 -163.02) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 633.65,
    y: 417.96,
    width: 38.01,
    height: 38.01,
    rx: 8.2,
    ry: 8.2,
    transform: "translate(500.14 -333.51) rotate(45)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoL);
export default __webpack_public_path__ + "static/media/logoL.b277c39ae850fd17c6565d0fd876a86d.svg";
export { ForwardRef as ReactComponent };